module.exports = __webpack_public_path__ + "img/IntelliBee-Logo.4d562f2a.png";